import resolve from '../../../../api-client';

import { REWARD__GET_IMMIDIATE } from '../constants';
import { getImmediateRewardUrl } from '../../util';

export const issueImmediateReward = (token) =>
  resolve({
    type: REWARD__GET_IMMIDIATE,
    url: getImmediateRewardUrl(),
    params: { token },
    retry: 3,
  });
